import Radio from './Radio.jsx';
import { FiChevronRight, FiX } from './react-icons/main';
import IconV2 from './v2/IconV2.jsx';

const OptionSelector = ({ isActive, isSelected, onClick, icon, leftIcon, rightIcon, label, description, descriptionAction, className = '', iconSize = 16, iconRight, chevronText = 'Change', useRadio = false, closable = false }) => {
  const handleClick = (e, action) => {
    e?.stopPropagation();
    e?.preventDefault();
    action?.onClick();
  };

  return (
    <div className={`comp-option-selector ${isActive ? 'active' : ''} ${isSelected ? 'selected' : ''} ${className}`} data-closable={closable} onClick={closable ? null : onClick}>
      {leftIcon && (
        <div className="left-icon">
          <IconV2 icon={leftIcon} size={iconSize} className="light-medium" />
        </div>
      )}
      <div className="left">
        <div className="title">
          {icon && <IconV2 icon={icon} className="light-medium" />}
          <span>{label}</span>
        </div>
        {description && (
          <div className="description">
            {description}
            {descriptionAction && (
              <div className="description-action" onClick={(e) => handleClick(e, descriptionAction)}>
                {descriptionAction.title}
              </div>
            )}
          </div>
        )}
      </div>
      {!useRadio && (
        <div className={'pointer-chevron'}>
          {(isSelected || chevronText !== 'Change') && <span>{chevronText}</span>}
          <IconV2 icon={closable ? FiX : iconRight || FiChevronRight} className={closable ? 'ghost' : ''} onClick={closable ? onClick : null} />
        </div>
      )}
      {useRadio && <Radio checked={className?.includes('-active')} />}
      {rightIcon && <div className={'right-icon'}>{rightIcon}</div>}
    </div>
  );
};

export default OptionSelector;
